import styled from 'styled-components';
//import shadowBg from '../../utils/assets/shadow-bg.png';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 137px;
  margin: 20px 0 55px;
  overflow: visible;
  background-color: #999999;
    &.pisa {
        background-color: #0073BC;
    }
    &.cremonese {
        background-color: #D80900FF;
    }
    &.salernitana {
        background-color: #841716;
    }
    &.lecce {
        background-color: #096086;
    }
    &.monza {
        background-color: #e4022e;
    }
    &.torino {
        background-color: rgb(108,27,21);
    }
    &.napoli {
        background-color: #5097d4;
    }
    &.atalanta {
        background-color: #0071BD;
    }
    &.benevento {
        background-color: #FFF001;
    }
    &.bologna {
        background-color: #282D95;
    }
    &.cagliari {
        background-color: #B30622;
    }
    &.chievo {
        background-color: #1E3C94;
    }
    &.crotone {
        background-color: #CC0001;
    }
    &.fiorentina {
        background-color: #420096;
    }
    &.genoa {
        background-color: #DA2A35;
    }
    &.inter {
        background-color: #0e4d8d;
    }
    &.juventus {
        background-color: #5e5e5e;
    }
    &.lazio {
        background-color: #87D8F7;
    }
    &.milan {
        background-color: #EC0002;
    }
    &.roma {
        background-color: #8C2B1A;
    }
    &.sampdoria {
        background-color: #008ED6;
    }
    &.sassuolo {
        background-color: #107B33;
    }
    &.parma{
        background-color: #e3c804;
    }
    &.empoli{
        background-color: #117ef8;
    }
    &.frosinone{
        background-color: #f8c411;
    }
    &.spal {
        background-color: #0093ED;
    }
    &.udinese {
        background-color: #666666;
    }
    &.verona {
        background-color: #F1D142;
    }
    &.arabia {
        background-color: #73AF00 !important;
    }
    &.algeria {
        background-color: #09a14a !important;
    }
    &.argentina {
        background-color: #9bcde7 !important;
    }
    &.australia {
        background-color: #ffbf00 !important;
    }
    &.belgio {
        background-color: #ff0000 !important;
    }
    &.bosnia-erzeg {
        background-color: #275498 !important;
    }
    &.brasile {
        background-color: #f0c948 !important;
    }
    &.camerun {
        background-color: #004e2f !important;
    }
    &.cile {
        background-color: #ff0000 !important;
    }
    &.colombia {
        background-color: #dfb802 !important;
    }
    &.corea-del-sud, &.corea.sud {
        background-color: #ee1111 !important;
    }
    &.costa-davorio {
        background-color: #ff8a15 !important;
    }
    &.costa-rica, &.costa.rica {
        background-color: #ff0000 !important;
    }
    &.croazia {
        background-color: #c01619 !important;
    }
    &.egitto {
        background-color: #FF4B55 !important;
    }
    &.ecuador {
        background-color: #ffdd00 !important;
    }
    &.francia {
        background-color: #0e428f !important;
    }
    &.germania {
        background-color: #80a272 !important;
    }
    &.ghana {
        background-color: #ffbf00 !important;
    }
    &.giappone {
        background-color: #000040 !important;
    }
    &.grecia {
        background-color: #0000be !important;
    }
    &.honduras {
        background-color: #0073cf !important;
    }
    &.inghilterra {
        background-color: #FF4B55 !important;
    }
    &.iran {
        background-color: #dd0000 !important;
    }
    &.italia {
        background-color: #005dab !important;
    }
    &.messico {
        background-color: #008032 !important;
    }
    &.nigeria {
        background-color: #008000 !important;
    }
    &.olanda {
        background-color: #ff6600 !important;
    }
    &.danimarca {
        background-color: #FF4B55 !important;
    }
    &.marocco {
        background-color: #FF4B55 !important;
    }
    &.panama {
        background-color: #FF4B55 !important;
    }
    &.perù {
        background-color: #FF4B55 !important;
    }
    &.portogallo {
        background-color: #ff0000 !important;
    }
    &.russia {
        background-color: #ff0000 !important;
    }
    &.spagna {
        background-color: #e3000b !important;
    }
    &.senegal {
        background-color: #FFE15A !important;
    }
    &.serbia {
        background-color: #41479B !important;
    }
    &.svizzera {
        background-color: #ff0000 !important;
    }
    &.stati-uniti {
        background-color: #ff0000 !important;
    }
    &.uruguay {
        background-color: #4b8cc1 !important;
    }
    &.romania {
        background-color: #1F5987 !important;
    }
    &.albania {
        background-color: #1F5987 !important;
    }
    &.russia {
        background-color: #1F5987 !important;
    }
    &.slovacchia {
        background-color: #1F5987 !important;
    }
    &.ucraina {
        background-color: #1F5987 !important;
    }
    &.polonia {
        background-color: #1F5987 !important;
    }
    &.irlanda-del-nord {
        background-color: #1F5987 !important;
    }
    &.galles {
        background-color: #1F5987 !important;
    }
    &.rep-ceca {
        background-color: #1F5987 !important;
    }
    &.turchia {
        background-color: #1F5987 !important;
    }
    &.tunisia {
        background-color: #FF4B55 !important;
    }
    &.irlanda {
        background-color: #1F5987 !important;
    }
    &.svezia {
        background-color: #1F5987 !important;
    }
    &.islanda {
        background-color: #1F5987 !important;
    }
    &.austria {
        background-color: #1F5987 !important;
    }
    &.ungheria {
        background-color: #1F5987 !important;
    }
    background-image: url("https://images2.gazzettaobjects.it/assets-mc/bkg/shadow-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    image-rendering: auto;
    image-rendering: crisp-edges;
    ${props => props.theme.mediaQueries.tablet_big_down}{
        min-height: 170px;
        margin: 30px 0 30px;
        background-size: auto;
        background-position: top;
    }
`;

export const CentralWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: baseline;
  margin-top: 0.8em;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    margin-top: 4em;
  };
`;

export const CentralInternalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.6em;
  ${props => props.theme.mediaQueries.tablet_big_down}{
   flex-direction: column;
  };
`;

export const BookmarkWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;

 ${props => props.theme.mediaQueries.tablet_big_down}{
  top: 10px;
  right: 10px;
 };
`;

export const TeamName = styled.div`
  color: white;
  font-size: ${props => (props.isMobile ? '2em' : '3.3em')};
  margin: 0;
  line-height: 1;
  text-align: center;
  font-family: ${props => props.theme.fontSets.condensedMedium};
  font-weight: 400;
`;

export const TeamNameH1 = styled.h1`
  color: white;
  font-size: ${props => (props.isMobile ? '2em' : '3.3em')};
  margin: 0;
  line-height: 1;
  text-align: center;
  font-family: ${props => props.theme.fontSets.condensedMedium};
  font-weight: 400;
`;



// WEBPACK FOOTER //
// ./src/lib/components/TeamHeader/styles.js